import React from 'react';
import { LoginShell } from '../Login/LoginShell';

export default function Maintenance() {
	return (
		<LoginShell>
			<div className="login-card maintenance-card">
				<h1 className="login-title">Scheduled maintenance</h1>
				<p className="login-description">
					Goodwill Projects stallholder login service is currently undergoing maintenance.
				</p>
				<p className="login-description">We&rsquo;ll be back online shortly.</p>
			</div>
		</LoginShell>
	);
}
